import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormHelper } from '@helpers/form.helper';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityModel } from '@data-layer/models/entities';

@Component({
  selector: 'self-filer-abi-client-representative-form',
  templateUrl: './self-filer-abi-client-representative-form.component.html',
  styleUrls: ['./self-filer-abi-client-representative-form.component.scss'],
})
export class SelfFilerAbiClientRepresentativeFormComponent implements OnInit, OnChanges {
  @Input() public entity: EntityModel = new EntityModel();
  public fg: UntypedFormGroup = this.fh.createEntityModelFormGroup();
  public errors: any;
  public CUSTOM_MASK = CUSTOM_MASK;
  public entityCode: enumEntityModelCode = enumEntityModelCode.ABI_CLIENT;

  constructor(private fh: FormHelper) {}

  public ngOnInit(): void {
    this.initForm();
    this.initErrors();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.entity) {
      if (!this.entity) {
        this.entity = new EntityModel({ entityCode: this.entityCode });
      } else {
        this.entity.entityCode = this.entityCode;
        this.fh.patchIsfEntity(this.fg, this.entity);
      }
    }
  }

  private initForm() {
    this.fg.get('entityCode').patchValue(this.entityCode);
  }

  private initErrors() {
    this.errors = {
      email: {
        maxLength: 'FORM_ERROR.MAX_LENGTH',
        pattern: 'FORM_ERROR.LOGIN_EMAIL',
      },
      phone: {
        maxlength: 'FORM_ERROR.MAX_LENGTH',
        validatePhoneNumber: 'FORM_ERROR.NOT_VALID_NUMBER',
      },
      fax: {
        maxlength: 'FORM_ERROR.MAX_LENGTH',
        validatePhoneNumber: 'FORM_ERROR.NOT_VALID_NUMBER',
      },
    };
  }
}
